// Estilos constantes para el componente Journals
export const COLORS = {
  primary: '#28a745',
  secondary: '#007bff',
  danger: '#f44336',
  warning: '#ef6c00',
  success: '#2e7d32',
  light: '#f5f5f5',
  white: '#fff',
  gray: '#ccc',
  darkGray: '#666',
  border: '#ddd',
  errorBg: '#ffebee',
  errorText: '#c62828',
  infoBg: '#e3f2fd',
  infoText: '#1976d2',
  infoBorder: '#2196f3',
  successBg: '#e8f5e8',
  warningBg: '#fff3e0',
  dangerBg: '#ffcdd2',
};

export const SPACING = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '20px',
  xxl: '30px',
  xxxl: '40px',
};

export const STYLES = {
  container: {
    maxWidth: '100%',
    margin: `${SPACING.xxxl} ${SPACING.xl}`,
    fontFamily: 'sans-serif',
  },
  formContainer: {
    maxWidth: 400,
    marginBottom: SPACING.xxl,
  },
  inputField: {
    marginBottom: SPACING.lg,
  },
  label: {
    display: 'block',
    marginBottom: SPACING.sm,
  },
  input: {
    width: '100%',
    padding: SPACING.sm,
    borderRadius: 4,
    outline: 'none',
    boxSizing: 'border-box',
  },
  errorContainer: {
    background: COLORS.errorBg,
    border: `1px solid ${COLORS.danger}`,
    borderRadius: 4,
    padding: SPACING.lg,
    margin: `${SPACING.xl} 0`,
    color: COLORS.errorText,
  },
  infoContainer: {
    marginBottom: SPACING.lg,
    padding: `${SPACING.sm} ${SPACING.md}`,
    background: COLORS.infoBg,
    border: `1px solid ${COLORS.infoBorder}`,
    borderRadius: 4,
    fontSize: '14px',
    color: COLORS.infoText,
  },
  loadingContainer: {
    textAlign: 'center',
    margin: `${SPACING.xl} 0`,
  },
  resultsContainer: {
    marginTop: SPACING.xxl,
  },
  summaryContainer: {
    background: COLORS.light,
    padding: SPACING.lg,
    borderRadius: 4,
    marginBottom: SPACING.xl,
  },
  tableHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: SPACING.lg,
  },
  tableContainer: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    border: `1px solid ${COLORS.border}`,
    background: COLORS.white,
  },
  tableHeaderCell: {
    padding: SPACING.md,
    border: `1px solid ${COLORS.border}`,
    textAlign: 'left',
    background: COLORS.light,
  },
  tableCell: {
    padding: SPACING.md,
    border: `1px solid ${COLORS.border}`,
    fontSize: '12px',
  },
  tableCellMono: {
    padding: SPACING.md,
    border: `1px solid ${COLORS.border}`,
    fontFamily: 'monospace',
    fontSize: '12px',
  },
  statusBadge: {
    padding: '4px 8px',
    borderRadius: 4,
    fontSize: '12px',
    fontWeight: 'bold',
  },
  emptyState: {
    textAlign: 'center',
    padding: SPACING.xxxl,
    background: '#f9f9f9',
    borderRadius: 4,
    color: COLORS.darkGray,
  },
};

export const getInputBorderColor = (value, isValid) => {
  if (value.length === 0) return COLORS.gray;
  return isValid ? 'green' : 'red';
};

export const getValidationTextColor = (isValid) => {
  return isValid ? 'green' : 'red';
};

export const getStatusBadgeStyle = (status) => {
  let bgColor = COLORS.successBg;
  let textColor = COLORS.success;

  if (status === 'need_revised') {
    bgColor = COLORS.dangerBg;
    textColor = COLORS.errorText;
  } else if (status === 'wait_to_synchronize') {
    bgColor = COLORS.warningBg;
    textColor = COLORS.warning;
  }

  return {
    ...STYLES.statusBadge,
    background: bgColor,
    color: textColor,
  };
};

export const getTableRowStyle = (index) => ({
  background: index % 2 === 0 ? COLORS.white : '#f9f9f9',
});
